export default
  "Mentions légales du site Solution Éco France (SAS, SIREN 982 431 033) — éditeur, hébergeur, statuts juridiques des trois pôles (travaux, courtage énergie B2B, mandataire CEE), médiation et signalement.";
